import axios from 'axios'

// state
export const state = {
  inviteUrl: false,
  isModalOpen: false,
  roundId: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchInviteUrlSuccess(state, { inviteUrl }) {
    state.inviteUrl = inviteUrl
  },
  setTeamCompleteModalVisibility(state, { isVisible, roundId }) {
    state.isModalOpen = isVisible
    state.roundId = roundId
  },
}
// actions
export const actions = {
  async openTeamCompleteModal({ commit, dispatch }, { roundId }) {
    dispatch('quests/quests/fetchQuests', null, { root: true })
    commit('setTeamCompleteModalVisibility', { isVisible: true, roundId })
  },
  async closeTeamCompleteModal({ commit }) {
    commit('setTeamCompleteModalVisibility', { isVisible: false, roundId: false })
  },
  async fetchInviteUrl({ commit }) {
    try {
      const response = await axios.get(`profile/inviteUrl`)
      commit('fetchInviteUrlSuccess', response)
    } catch (error) {
    }
  },
}
